import React, { useContext } from 'react'
import { Box, Text } from '@usap/uicomponents'
import { SelectedItemsContext } from '../../../../contexts/SelectedItemsContextProvider'
import { Heading4 } from '../../../common/heading'
import MultiItemBox from './MultiItemBox'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import RMAReturnOrderInfoWMO from './RMAReturnOrderInfoWMO'

const viewYearOrder = dateOrder => {
  const nowDateOptions = { weekday: 'short', month: 'short', day: '2-digit' }
  const pastDateOptions = { month: 'short', day: '2-digit', year: 'numeric' }
  const yearNow = new Date().getFullYear()
  const yearData = new Date(dateOrder).getFullYear()
  if (yearData < yearNow) {
    return pastDateOptions
  }
  return nowDateOptions
}

const RMAReturnOrderInfo = ({
  merchantOrderId,
  orderDate,
  isMultiplePart,
  errorSteps,
  setItemImage,
  showTabs,
  selectedPartIndx,
  isDesktop,
  selectedPart,
  showReason,
  multipleItemsPresent,
}) => {
  const isTransToReasons = !showTabs
  const selectedItemsContext = useContext(SelectedItemsContext)
  const { orderItems } = selectedItemsContext

  let transTextAlign = 'right'
  if ((!isDesktop && !showTabs)
    || (showTabs && orderItems.length)
    || selectedPart) {
    transTextAlign = 'left'
  }
  const dateOptions = viewYearOrder(orderDate)
  const formatedDate = new Intl.DateTimeFormat('en-US', dateOptions).format(new Date(orderDate))

  const transDirection = isTransToReasons && isDesktop && !selectedPart ? 'row': 'column'
  const styleDesktop = {
    width: isDesktop && !selectedPart ? '50%' : '100%',
    height: '21px',
  }
  const boxMargin = '8px'
  const dateStyle = {
    width: isDesktop && !selectedPart ? '50%' : '100%',
    height: '21px',
    textAlign: transTextAlign,
  }
  const enabled = (isMultiplePart && !selectedPart) && showReason

  const isWmoEnabled = useWmoEnabled()

  if(isWmoEnabled) {
    return (<RMAReturnOrderInfoWMO
      merchantOrderId={merchantOrderId}
      errorSteps={errorSteps}
      setItemImage={setItemImage}
      showTabs={showTabs}
      selectedPartIndx={selectedPartIndx}
      isDesktop={isDesktop}
      formatedDate={orderDate}
      enabled={enabled}
      multipleItemsPresent={multipleItemsPresent}
    />)
  }

  return (
    <>
      <Box margin={{ bottom: boxMargin }}>
        {enabled && (
        <Box width="100%" alignContent="center" alignSelf="center">
          <Heading4
            size="small"
            color="dark-2"
            title="Choose part to return"
            margin="10px 0"
          />
        </Box>
        )}
        <Box width="100%" alignContent="center" alignSelf="center" direction={transDirection}>
          <Text size="small" color="dark-2" style={styleDesktop}>
            Order Number:
            {` ${merchantOrderId}`}
          </Text>
          {selectedPart && (
            <Text size="small" color="dark-2" style={styleDesktop}>
              Part No.:
              {` ${selectedPart}`}
            </Text>
          )}
          <Text size="small" color="dark-2" style={dateStyle}>
            Date Purchased:
            {` ${formatedDate}`}
          </Text>
        </Box>
        <Box id="error-ReturnPart" width="100%">
          <Text style={{ color: '#f90000', fontSize: '12px' }}>
            {errorSteps.errorReturnPart}
          </Text>
        </Box>
      </Box>
      {showTabs && (
      <Box id="multiItemBox">
        <MultiItemBox
          setItemImage={setItemImage}
          activeCount={selectedPartIndx}
          isDesktop={isDesktop}
        />
      </Box>
      )}
    </>
  )
}

export default RMAReturnOrderInfo
